<template>
  <div>
    <template v-if="loading">
      <content-placeholders>
        <content-placeholders-text :lines="2"/>
      </content-placeholders>
    </template>
    <template v-else>
      <div class="catalog-view__box" v-if="product.tnvdCode">
        <div class="catalog-view__activity-head">
          <div class="catalog-view__subtitle catalog-view__subtitle-activity">Код ТН ВЭД</div>
        </div>
        <div class="catalog-view__table-chars">
          <table class="catalog-view__table">
            <tbody>
            <tr>
              <th style="width: 10%"><strong>{{ product.tnvdCode.code }}</strong></th>
              <td>{{ product.tnvdCode.description }}</td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </template>
  </div>
</template>

<script>

export default {
  name: 'tnvd',
  components: {},
  props: {
    product: {
      require: true
    }
  },
  data: () => ({
    loading: true
  }),
  created() {
    this.loading = false
  },
  methods: {}
}
</script>